import { render, staticRenderFns } from "./CloseWizard.vue?vue&type=template&id=9365c4fc&"
import script from "./CloseWizard.vue?vue&type=script&lang=js&"
export * from "./CloseWizard.vue?vue&type=script&lang=js&"
import style0 from "./CloseWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports